import React from 'react';
import { IonCol, IonContent, IonFooter, IonGrid, IonIcon, IonImg, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonRow, IonText } from '@ionic/react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { chevronForwardOutline, chevronForwardSharp } from 'ionicons/icons';
import './Menu.css';
import { useGA4React } from 'ga-4-react';

const Menu: React.FC = () => {
  const location = useLocation();
  const [t] = useTranslation();
  const ga4 = useGA4React();

  if (ga4)
    ga4.pageview(location.pathname);

  const headerSrc = "assets/corp/" + t('LogoSrc');
  const footerSrc = "assets/corp/" + t('PahoLogoSrc');

  return (
    <IonMenu contentId="main" type="overlay">
      <IonContent>
        <IonGrid>
          <IonRow class="ion-justify-content-center">
            <IonCol size="8">
              <IonImg src={headerSrc} />
            </IonCol>
          </IonRow>
        </IonGrid>
        <IonList style={{ marginTop: '50px' }}>
        {/* <IonItem className={location.pathname === '/optimizerisk' ? 'selected' : ''} routerLink="/optimizerisk" routerDirection="none" lines="none" detail={false}>
            <IonIcon ios={chevronForwardOutline} md={chevronForwardSharp} />
            <IonLabel className="ion-text-wrap">{t('HowToOptimizeRisk')}</IonLabel>
          </IonItem>*/}
          <IonItem routerDirection="none" lines="none" detail={false}>
            <IonIcon ios={chevronForwardOutline} md={chevronForwardSharp} />
            <IonLabel className="ion-text-wrap">{t("SelectCalculate")}</IonLabel>
          </IonItem>
          <IonItem className={location.pathname === '/howtobloodpressure' ? 'selected' : ''} routerLink="/howtobloodpressure" routerDirection="none" lines="none" detail={false}>
            <IonIcon ios={chevronForwardOutline} md={chevronForwardSharp} />
            <IonLabel className="ion-text-wrap">{t("HowToBloodPressure")}</IonLabel>
          </IonItem>        
          <IonItem className={location.pathname === '/cvrisk' ? 'selected' : ''} routerLink="/cvrisk" routerDirection="none" lines="none" detail={false}>
              <IonIcon ios={chevronForwardOutline} md={chevronForwardSharp} />
              <IonLabel className="ion-text-wrap">{t("Cardiovascular Risk")}</IonLabel>
            </IonItem>
          <IonItem className={location.pathname === '/recommendations' ? 'selected' : ''} routerLink="/recommendations" routerDirection="none" lines="none" detail={false}>
              <IonIcon ios={chevronForwardOutline} md={chevronForwardSharp} />
              <IonLabel className="ion-text-wrap">{t("Recommendations")}</IonLabel>
          </IonItem>
          <IonItem routerDirection="none" lines="none" detail={false}>
            <IonIcon ios={chevronForwardOutline} md={chevronForwardSharp} />
            <IonLabel className="ion-text-wrap">{t("OtherCalculations")}</IonLabel>
          </IonItem>
          <IonMenuToggle className="subMenu" autoHide={false}>
              <IonItem className={location.pathname === '/renalrisk' ? 'selected' : ''} routerLink="/renalrisk" routerDirection="none" lines="none" detail={false}>
              <IonIcon ios={chevronForwardOutline} md={chevronForwardSharp} />
              <IonLabel className="ion-text-wrap">{t("Glomerular Filtration")}</IonLabel>
            </IonItem>
            <IonItem className={location.pathname === '/bodymassindex' ? 'selected' : ''} routerLink="/bodymassindex" routerDirection="none" lines="none" detail={false}>
              <IonIcon ios={chevronForwardOutline} md={chevronForwardSharp} />
              <IonLabel className="ion-text-wrap">{t("Body Mass Index")}</IonLabel>
            </IonItem>
          </IonMenuToggle>
            <IonItem className={location.pathname === '/description' ? 'selected' : ''} routerLink="/description" routerDirection="none" lines="none" detail={false}>
            <IonIcon ios={chevronForwardOutline} md={chevronForwardSharp} />
            <IonLabel className="ion-text-wrap">{t("Introduction Title")}</IonLabel>
          </IonItem>
          <IonItem routerLink="/" onClick={()=> window.open(t("HEARTS Link"), "_blank")} routerDirection="none" lines="none" detail={false}>
              <IonIcon ios={chevronForwardOutline} md={chevronForwardSharp} />
              <IonLabel className="ion-text-wrap">{t("HEARTS Title")}</IonLabel>
          </IonItem>
        </IonList>
      </IonContent>
      <IonFooter className="ion-no-border">
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol size="7">
              <IonImg src={footerSrc} />
            </IonCol>
          </IonRow>
          <IonRow className="ion-justify-content-center">
            <IonCol size="7">
              <IonText>
                {t('OfficialText')}
              </IonText>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonFooter>
    </IonMenu>
  );
};

export default Menu;
